import React from 'react';
import { bonuses } from '../data/content';
export function Bonuses() {
  return <section className="bg-deep px-4 py-5 sm:px-6" data-id="element-18" data-mp="pjpx9t6ljn8q">
      <div className="mx-auto max-w-2xl" data-id="element-19" data-mp="pjg7a5ljxg31">
        <h2 className="text-center font-heading text-lg font-extrabold uppercase text-glow sm:text-3xl" data-id="element-20" data-mp="avcxsm8avm9h">
          🎁 5 Professional Bonuses Included
        </h2>
        <div className="mt-3 space-y-2.5" data-id="element-21" data-mp="fsbrx4ryrt7o">
          {bonuses.map(bonus => <article key={bonus.number} className="rounded-xl border-l-4 border-turq bg-white p-3 shadow-sm" data-id="element-22" data-mp="1tlv7q923vju">
              <h3 className="font-heading text-[0.78rem] font-extrabold uppercase leading-tight text-deep sm:text-base" data-id="element-23" data-mp="3o1v5efaefsp5">
                🎁 Bonus {bonus.number} — {bonus.title}
              </h3>
              <p className="mt-0.5 font-heading text-[0.72rem] font-semibold text-turq sm:text-sm" data-id="element-24" data-mp="1ma8l0wl0iw1n">
                {bonus.subtitle}
              </p>
              <p className="mt-1 text-[0.86rem] leading-snug text-muted sm:text-base" data-id="element-25" data-mp="1r80azl23k837">
                {bonus.body}
              </p>
              <p className="mt-1 font-heading text-[0.72rem] font-bold uppercase tracking-wide text-clinical sm:text-sm" data-id="element-26" data-mp="3ic3ik6qg2wea">
                {bonus.steps}
              </p>
            </article>)}
        </div>
      </div>
    </section>;
}